import { Spacer } from "../common/Spacer";
import { UserOutlined, VideoCameraOutlined } from "@ant-design/icons";
import { Wrapper } from "./styles";
import { useTranslation } from "react-i18next";
import React from "react";

export const AttentionTypeButton = ({
	type = "videocall",
	onClick,
	desktop,
}) => {
	const { t } = useTranslation(["booking"]);
	const objConfig = {
		videocall: {
			icon: <VideoCameraOutlined style={{ fontSize: 24 }} />,
			label: t("attentionByVideoCall"),
		},
		"face-to-face": {
			icon: <UserOutlined style={{ fontSize: 24 }} />,
			label: (
				<>
					<div>{t("attention")}</div>
					<div>{t("faceToFace")}</div>
				</>
			),
		},
	};

	return (
		<Wrapper desktop={desktop} onClick={onClick} type={type}>
			{objConfig[type].icon}
			<Spacer rows={0.5} />
			<div className="attention-type-label">{objConfig[type].label}</div>
		</Wrapper>
	);
};
